import React from "react";

import { useTranslation } from "react-i18next";
import { BsInfoCircle } from "react-icons/bs";

import { PurchaseOrder } from "../../../../models/purchase.order";
import { ViewOnly } from "../../../../types";
import ShipmentOrders from "../../../Generic/ShipmentOrders";
import { PurchaserOrderFrom } from "../../../Generic/ShipmentOrders/types";
import { useBookingResources } from "../../context/AvailableOrders";
import { useBookingContext } from "../../context/Booking";
import useStyles from "./styles";

interface BookingOrdersProps {
  purchaseOrders: PurchaseOrder[];
  onAddPurchaseOrder?: (orders: PurchaseOrder[]) => void;
  onRemovePurchaseOrder?: (order: PurchaseOrder) => void;
  viewOnly: ViewOnly;
  loadingOrders: boolean;
  fromMaintenance?: boolean;
  openedFromView?: boolean;
}

const BookingOrders: React.FC<BookingOrdersProps> = (props) => {
  const {
    purchaseOrders,
    onAddPurchaseOrder,
    onRemovePurchaseOrder,
    viewOnly: viewMode,
    loadingOrders,
    fromMaintenance,
  } = props;
  const { t: translate } = useTranslation();
  const classes = useStyles();
  const { booking } = useBookingContext();
  const { orderList, refetchOrderList, isLoading: loadingOrderList } = useBookingResources();

  const renderTitle = () => (
    <div className={classes.tooltipContainer}>
      {!booking?.shipmentType && (
        <div className={classes.tooltipTitle}>
          <BsInfoCircle />
          <span>{translate("youMustSelectABookingModeFirst")}</span>
        </div>
      )}
      {!booking?.portOfLoadingId && (
        <div className={classes.tooltipTitle}>
          <BsInfoCircle />
          <span>{translate("youMustSelectABookingLoadingPortFirst")}</span>
        </div>
      )}
      {!booking?.portOfDischargeId && (
        <div className={classes.tooltipTitle}>
          <BsInfoCircle />
          <span>{translate("youMustSelectABookingDischargePortFirst")}</span>
        </div>
      )}
      {!booking?.cargoReadyDate && (
        <div className={classes.tooltipTitle}>
          <BsInfoCircle />
          <span>{translate("youMustSelectedABookingCargoReadyDateFirst")}</span>
        </div>
      )}
    </div>
  );

  return (
    <div className={classes.mainDiv} data-cy="orders-container">
      <ShipmentOrders
        purchaseOrders={purchaseOrders}
        viewOnly={viewMode}
        onAddPurchaseOrder={onAddPurchaseOrder}
        onRemovePurchaseOrder={onRemovePurchaseOrder}
        loadingOrders={loadingOrders}
        orderList={orderList}
        refetchOrderList={refetchOrderList}
        loadingOrderList={loadingOrderList}
        addButton={{
          tooltip: renderTitle(),
          disableButton:
            !booking?.shipmentType ||
            !booking.portOfDischargeId ||
            !booking.portOfLoadingId ||
            !booking.cargoReadyDate,
        }}
        calledFrom={PurchaserOrderFrom.BOOKING}
        fromMaintenance={fromMaintenance}
      />
    </div>
  );
};

export default BookingOrders;
